import { MagnifyingGlass, MapPin } from '@phosphor-icons/react';
import Modal from '../../../shared/components/Modal';

type MapSearchPlacesModalProps = {
  places: any[];
  query: string;
  t: any;
  onClose: () => void;
  onOpen: (place: any) => void;
};

export default function MapSearchPlacesModal({
  places,
  query,
  t,
  onClose,
  onOpen,
}: MapSearchPlacesModalProps) {
  return (
    <Modal label={t.searchResultsTitle} onClose={onClose}>
      <div className="modal-head map-search-places-head">
        <span className="eyebrow coral"><MagnifyingGlass weight="bold" />{t.searchResultsTitle}</span>
        <h2>“{query}”</h2>
        <p>{places.length} {t.results}</p>
      </div>
      <div className="tag-places-list map-search-places-list">
        {places.map((place) => (
          <button type="button" key={place.id} onClick={() => onOpen(place)}>
            <img src={place.image || '/place-placeholder.svg'} alt="" />
            <span>
              <b>{place.name}</b>
              <small><MapPin weight="fill" />{place.address}</small>
            </span>
          </button>
        ))}
      </div>
    </Modal>
  );
}
